export default "__VITE_ASSET__9ae7ca84__"